<template>
  <div class="anniversary_page">
    <!-- 活动标题 -->
    <div v-wechat-title="'《使魔计划》周年庆典'"></div>
    <!-- 首页进入青瓷游戏LOGO -->
    <transition enter-active-class='animated fadeIn' leave-active-class='animated fadeOut' name='fade'>
      <div @touchmove.prevent class='preloading preloading-smjh' v-show='preloadingShow'></div>
    </transition>
    <div class="content">



      <div class="swiper-container " ref="mySwiper">
        <div class="swiper-wrapper">
          <div class="swiper-slide">
            <div class="first_page ">

              <div class="logo"></div>
              <div class="title"></div>
              <div class=" download-btn download  android" @click="help"></div>
              <div class="arrow_down ani-01" @click="nextPage"></div>
            </div>
          </div>
          <div class="swiper-slide foot-page">
            <Footer :gameName="gameName" />
          </div>
        </div>
      </div>


    </div>
    <div class="header">

      <div class="active" @click="goIndex"></div>
    </div>




    <!-- <Header :config="headerConfig" :isShowInfo="true" :isOnline="1" /> -->
    <!-- 登录弹窗 -->
    <Login v-if="isShowLogin" v-on:channelCallback="selectCallback" :gameName="gameName" :loginTypes="loginTypes"
      :downloadUrl="downloadUrl" channelTips="角色UID可在游戏中—设置—UID查看" noAuthLogin></Login>
    <Os v-if="isShowOs" v-on:selectCallback="selectCallback" v-on:logoutCallback="osCancell" :gameName="gameName"></Os>

    <!-- 弹窗类 -->

    <!-- 视频详情 -->


    <!-- 分享结果弹窗 -->
    <div class="assist_wrap popup_wrap" v-show="assistShow" @click="closePopup('assistShow')">
      <transition enter-active-class="animated fade-enter-active" leave-active-class="animated fade-leave-active"
        :duration="{ enter: 1000 }" v-show="assistShow">
        <div class="detail_box" :style="divStyle" v-show="assistShow">
          <div class="detail">

            <div class="text" v-if="assistMsg200">
              <div>助力成功~</div>
              <div>您的助力次数还剩<span class="text-w">{{ helpNum }}</span>次</div>
            </div>

            <div class="text" v-if="assistMsg404">
              您不能给自己助力
            </div>
            <div class="text" v-if="assistMsg405">
              <div>很抱歉，</div>
              <div>您助力过该玩家了~</div>
            </div>
            <div class="text" v-if="assistMsg406">
              <div>助力失败~</div>
              <div>您的助力次数已用完</div>
            </div>
            <div class="text" v-if="assistMsg407">
              <div>助力失败~</div>
              <div>对方今日获得助力次数已满</div>
              <div class="text-mini">（本次不消耗助力次数）</div>
            </div>
            <div class="btn" @click="goIndex"></div>
          </div>
        </div>
      </transition>
    </div>

    <!-- 全局遮罩 -->
    <div :class="'prevent-wrap prevent-wrap-' + preventShow"></div>

  </div>
</template>




<script>

import Header from '@/components/Header/index';
import Footer from "@/components/Footer";
import { headerConfig } from "../headerConfig";

import MySwiper from '@/components/MySwiper';
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'



import { Toast, Indicator } from 'mint-ui';
import { mapState, mapMutations, mapActions } from 'vuex';
import Os from '@/components/os';
import Login from '@/components/login';
import { onGetInitHlepDataAPI, lottery, help } from '../api';
import { getRandomString, buriedLogger, wechatBrowser, getTimeStamp } from '@/utils/utils';
import { generateQRCode, generateCanvasImage } from '@/utils/share';


export default {

  name: 'anniversary',
  components: {
    swiper,
    swiperSlide,
    MySwiper,
    Header,
    Footer,
    Login,
    Os
  },
  data() {
    return {
      mdv: [
        {
          photo: 'https://download4.qcplay.com/h5-images/active/servitor/anniversary/main/show_2.png'
        },
        {
          photo: 'https://download4.qcplay.com/h5-images/active/servitor/anniversary/main/show_3.png'
        },
        {
          photo: 'https://download4.qcplay.com/h5-images/active/servitor/anniversary/main/show_1.png'
        },
        {
          photo: 'https://download4.qcplay.com/h5-images/active/servitor/anniversary/main/show_4.png'
        },
        {
          photo: 'https://download4.qcplay.com/h5-images/active/servitor/anniversary/main/show_5.png'
        }
      ],
      assistImg: 'https://download4.qcplay.com/h5-images/active/servitor/anniversary/main/fail.png',
      headerConfig,
      noSwiperClass: '', // swiper-no-swiping
      gameName: "servitor",
      loginTypes: ["sms", "password", "channel"],
      downloadUrl: 'http://smjh.qingcigame.com/leading/',
      preloadingShow: true,
      titleShow: false,
      imagePath: 'https://download4.qcplay.com/h5-images/active/servitor/anniversary/main/party.png',
      imagePath1: 'https://download4.qcplay.com/h5-images/active/servitor/anniversary/main/gift.png',
      imagePath2: 'https://download4.qcplay.com/h5-images/active/servitor/anniversary/main/carnival.png',
      swiperA: null,

      prizeListShow: false, // 奖品列表 弹窗
      myPrizeShow: false, // 奖品列表 弹窗
      ruleShow: false, // 奖品列表 弹窗
      cakeShow: false, //蛋糕列表 弹窗
      videoShow: false, //视频列表 弹窗
      GifImages: [],
      active_Info: {
        reward_list: [],
        times: 0
      }, // 活动信息
      user_info: {}, // 用户信息
      currentIndex: 1,
      gifInterval: null, // 定时器
      isUserInfo: false, // 是否获取用户信息
      shareLink: '',
      // 号码后4位id
      accountId: '',
      // 复制使用的文案
      clipInfo: '',
      shareShow: false,
      shareImg: null,
      getPriceShow: null,// 是否抽中奖
      priceShow: null,// 是否抽中奖
      isVideo: false, // 是否为视频
      wxShow: false,
      preventShow: false,
      paymentTipsShow: false,
      assistShow: false, // 助力弹窗
      assistMsg404: false, // 助力弹窗
      assistMsg405: false, // 助力弹窗
      assistMsg406: false, // 助力弹窗
      assistMsg407: false, // 助力弹窗
      assistMsg200: true, // 助力弹窗
      helpNum: 0,

      isWechatBrowser: false, // 是否为微信浏览器
      wxLoadShow: false,
      swiper: null
    };
  },
  created() {
    var userAgent = navigator.userAgent.toLowerCase();
    var isPC = userAgent.indexOf('windows') > -1 || userAgent.indexOf('macintosh') > -1;

    // if (isPC) {
    //   this.$router.push('pc');
    //   console.log('当前设备是 PC');
    // } else {
    //   console.log('当前设备不是 PC');
    // }


    this.getUserInfo()
    this.setInitActiveInfo();
    this.setInitUserInfo();


    this.isWechatBrowser = wechatBrowser();

    // 埋点
    const bl = buriedLogger('servitor', '使魔计划周年庆活动助力页');
    this.logger = bl;

    const reload = () => {
      const { protocol, host } = window.location;
      const link = `${protocol}//${host}/servitor/anniversary/help${getRandomString()}`;
      setTimeout(() => {
        window.location.href = `${link}?referer=game`;
      }, 200);
    };
  },
  mounted() {
    this.swiper = new Swiper('.swiper-container', {
      direction: 'vertical',
      resistanceRatio: 0,
      mousewheelControl: true,
      speed: 500,
      slidesPerView: 'auto',
      lazyLoading: true,
      lazyLoadingInPrevNext: true,
      preloadImages: false,
      observer: true,
      observeParents: true,

    });
  },
  computed: {
    ...mapState(["userInfo", "activeInfo", "isShowLogin", "isShowOs"]),
    divStyle() {
      return {
        backgroundImage: `url(${this.assistImg})`
      };
    }
  },
  watch: {
    userInfo: {
      handler(newValue, oldValue) {
        if (!newValue.role_id) {
          // TAG: 注销的时候
          this.clearActiveInfo();
        }
      }
    },
    activeInfo: {
      handler(newValue, oldValue) {
        if (Object.keys(newValue).length > 0) {
          const { countdown_time = '', is_echarge } = newValue;
          this.showPayBtn = is_echarge === false;
          if (countdown_time) {
            const date = new Date(countdown_time);
            const curDate = new Date();
            const year = date.getFullYear();
            const month = date.getMonth() + 1;
            const day = date.getDate();
            this.isExpired = curDate.getTime() > date.getTime();
            this.endDate = `${year}年${month}月${day > 9 ? day : ('0' + day)}日`
          } else {
            this.isExpired = true;
            this.endDate = '';
          }
        }
      }
    },
  },
  methods: {
    goIndex() {
      this.logger.sum('使魔计划周年庆H5，跳转周年庆活动页');
      this.$router.push({ path: '/anniversary/index' })
    },
    // 业务代码
    help() {
      this.assistMsg405 = false
      this.assistMsg404 = false
      this.assistMsg406 = false
      this.assistMsg407 = false
      this.assistMsg200 = false
      const params = {
        friend_id: this.$route.query.friend_id || null
      }
      const that = this
      this.assistImg = 'https://download4.qcplay.com/h5-images/active/servitor/anniversary/main/fail.png'
        console.log(1111)
      help(params).then((res) => {
        const { code, message } = res;

        this.logger.sum('使魔计划周年庆H5，参与助力');
        switch (code) {
          case 200:
            that['assistMsg' + code] = true
            that.onToast(message);
            this.assistImg = 'https://download4.qcplay.com/h5-images/active/servitor/anniversary/main/success.png'
              this.$set(that, 'helpNum', that.helpNum - 1)
            break;
          case 405:
            that['assistMsg' + code] = true
            that.onToast(message);
            break;
          case 404:
            that['assistMsg' + code] = true
            that.onToast(message);
            break;
          case 406:
            that['assistMsg' + code] = true
            that.onToast(message);
            break;
          case 407:
            that['assistMsg' + code] = true
            that.onToast(message);
            break;
          default:
            that.onToast(message);
            break;
        }
        that.getUserInfo()

        that.assistShow = true
      })
    },
    nextPage() {
      this.swiper.slideNext()
    },
    closeVideo() {
      this.isVideo = false
      this.$refs.videoRef.pause()
    },
    playVideo() {
      this.isVideo = true
      this.$refs.videoRef.play()
    },
    assist() {
      this.assistShow = true
    },
    goHere(link) {
      window.location.href = link
    },
    closeShare() {
      this.shareShow = false;
    },

    initShareData() {
      console.log('initShareData', this.user_info)
      try {
        const { protocol, host } = window.location;
        console.log('user_info', this.user_info);
        this.shareLink = `${protocol}//${host}/servitor/anniversary/help${getRandomString()}?friend_id=` + this.user_info.user_id;
        console.log('shareLink', this.shareLink);
        // this.shareLink = 'http://local.qingcigame.com:8081/servitor/anniversary/index'
        this.isSetShare({ link: this.shareLink });
        this.qrcode(this.shareLink);
        this.$nextTick(() => {
          this.generateShareImage();
        });
        // 例如：获取好友助力信息等
      } catch (err) {
        // 错误信息
        console.log('err', err);
      }
    },
    // 分享图片设置
    generateShareImage() {
      if (this.$refs.imageDom !== undefined) {
        generateCanvasImage(this.$refs.imageDom)
          .then((canvas) => {
            console.log(canvas, 'canvas')
            this.preventShow = false;
            this.shareImg = canvas.toDataURL('image/png'); // 可将 canvas 转为 base64 格式
            console.log('success: 图片生成成功');
            Indicator.close();
          })
          .catch((err) => {
            this.preventShow = false;
            Indicator.close();
            console.log('err: 图片生成失败', err.message);
          });
      }

    },
    // 微信分享
    isSetShare(linkUrl) {
      this.setShare({
        link: linkUrl + `${getTimeStamp()}`,
        title: '《使魔计划》周年庆典',
        imgUrl:
          'https://download4.qcplay.com/qcgame-admin/yTzSgoBsGBKICdfLlnUcy1pnfgNagaeLl3bcvtgP.png',
        desc: '《使魔计划》周年庆典现已开启！签到领取100抽，五星使魔以及橙色装备零元购，快来参与庆典吧！',
      })
    },
    qrcode(link) {
      generateQRCode(document.getElementById('qrcode'), {
        text: link,
        colorDark: '#b8957e',
        colorLight: '#f3eadb'
      });
    },
    monitoringEquipment() {
      if (!navigator.userAgent.match(/(iPhone|iPod|Android|ios)/i)) location.href = `https://h5.qingcigame.com/sakura/lottery/pc${getTimeStamp()}`
    },
    share() {
      if (this.isUserInfo) {
        return this.onToast('很抱歉，请先登录')
      }
      this.shareShow = true
    },
    importAll(r) {
      return r.keys().map(r);
    },


    lottery() {
      const that = this
      lottery().then((response) => {
        if (response.code == 200) {
          console.log(response.data.prize_id, 'response.data.price_id')
          that.priceShow = `https://download4.qcplay.com/h5-images/active/servitor/anniversary/main/${response.data.prize_id}.png`
          console.log(that.priceShow, '   that.priceShow')
          this.cakeShowClose()
        } else {
          this.onToast(response.message);
        }
        console.log(response)
      }).catch((e) => {
        console.log(e)

      })
    },
    // 获取用户信息
    async getUserInfo() {
      const params = {
        friend_id: this.$route.query.friend_id || ''
      }
      await onGetInitHlepDataAPI(params).then(response => {
        this.onInitDataCallback(response);
        this.preloadingShow = false;
        this.titleShow = true;
        if (response.code === 200) {
          this.helpNum = response.data.help_times;
          this.$set(this, 'helpNum', response.data.help_times)

        } else {
          this.isUserInfo = true
          this.onToast(response.message);
          this.setInitUserInfo();
          this.setInitActiveInfo();
        }
      }).catch(() => {
        this.preloadingShow = false;
        this.titleShow = true;
      });
    },
    videoShowClose() {

    },
    cakeShowClose() {
      const that = this
      that.cakeShow = true;
      that.getUserInfo()
      setTimeout(() => {
        that.closePopup('cakeShow')
        that.getPriceShow = true
      }, 6000)
    },

    // 清除data里面相关数据
    clearActiveInfo() {
      this.showPayBtn = true;
      this.endDate = '';
      this.isExpired = false;
    },
    // 选择角色后
    selectCallback() {
      this.getUserInfo();
    },
    osCancell() {
      this.active_Info = []
      this.user_info = []
      this.isUserInfo = true;
    },
    // TAG: 其他简易封装的方法
    openPopup(name) {
      if (this.isUserInfo) {
        console.log('请先登录')
        return this.onToast('很抱歉，请先登录');
      }
      this[name] = true;
    },
    closePopup(name) {
      this[name] = false;
    },
    onToast(config) {
      const curConfig = {
        duration: 1000,
        className: "toasts"
      };
      if (!config) {
        console.error("缺少config参数");
        return false;
      }
      if (typeof config === "string") {
        curConfig.message = config;
      }
      Toast(curConfig);
    },
    ...mapMutations([
      "changeLoginPopup",
      "changeOsPopup",
      "setInitActiveInfo",
      "setInitUserInfo",
      "setActiveInfo",
      "setLogger"
    ]),
    ...mapActions(["onInitDataCallback", "setShare"])
  }
};
</script>

<style lang="less" scoped>
@import url("./index.less");
</style>
 


// WEBPACK FOOTER //
// src/pages/servitor/anniversary/help/index.vue